import apiClient from "./client";

const API_BASE = process.env.REACT_APP_API_URL || "/api/v1";

export async function getListings({ search, type, status, page = 1, limit } = {}) {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (type) params.set("type", type);
  if (status) params.set("status", status);
  params.set("page", String(page));
  if (limit) params.set("limit", String(limit));
  return apiClient.get(`/realestate?${params.toString()}`);
}

export async function getListing(id) {
  return apiClient.get(`/realestate/${id}`);
}

export async function getAdminListings() {
  return apiClient.get("/realestate/admin/all");
}

export async function getPendingListings() {
  return apiClient.get("/realestate/pending");
}

export async function getMyListings() {
  return apiClient.get("/realestate/my");
}

export async function createListing(data) {
  return apiClient.post("/realestate", data);
}

export async function submitListing(data) {
  return apiClient.post("/realestate/submit", data);
}

export async function publishListing(id, isPublished) {
  return apiClient.patch(`/realestate/${id}/publish`, { isPublished });
}

export async function updateListing(id, data) {
  return apiClient.put(`/realestate/${id}`, data);
}

export async function deleteListing(id) {
  return apiClient.delete(`/realestate/${id}`);
}

export async function uploadListingImage(listingId, file, caption) {
  const formData = new FormData();
  formData.append("image", file);
  if (caption) formData.append("caption", caption);

  const headers = {};
  if (apiClient.accessToken) {
    headers["Authorization"] = `Bearer ${apiClient.accessToken}`;
  }

  const response = await fetch(`${API_BASE}/realestate/${listingId}/images`, {
    method: "POST",
    headers,
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Upload failed");
  }
  return data;
}

export async function deleteListingImage(listingId, imageId) {
  return apiClient.delete(`/realestate/${listingId}/images/${imageId}`);
}
